import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


interface IAccordionProps {
  expandOnDefault: boolean;
  label: React.ReactNode;
  summaryActions?: React.ReactNode;
  children: React.ReactNode;
  backgroundColor?: string;
  iconFill?: string;
  textColor?: string;
  avatar?: React.ReactNode;
  fontSize?: string;
  opacity?: string;
  height?: string;
  onExpandChange?: (expanded: boolean) => void;
}

const AppAccordion = (props: IAccordionProps) => {
  const hasSideSlots: boolean = Boolean(props.avatar) || Boolean(props.summaryActions);
  return (
    <Accordion defaultExpanded={props.expandOnDefault} onChange={(_event, expanded) => props.onExpandChange?.(expanded)} >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ fill: props.iconFill ? props.iconFill : "white" }} />}
        aria-controls="scorecardDetails"
        id="scorecardDetails"
        sx={{
          backgroundColor: props.backgroundColor ? props.backgroundColor : "#4d4f53",
          height: props.height ?? '30px',
          opacity: props.opacity ?? '100%'
        }}
      >
        <Grid container>
          {props.avatar && 
            <Grid item xs={1}>
              {props.avatar}
            </Grid>
          }
          <Grid item xs={hasSideSlots ? 10 : 12}>
            <Typography sx={{ color: props.textColor ? props.textColor : '#ffffff', fontSize: props.fontSize || 'inherit'}}>
                {props.label}
            </Typography>
          </Grid>
          {hasSideSlots && (
            <Grid item xs={1}>
              {props.summaryActions}
            </Grid>
          )}
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        {props.children}
      </AccordionDetails>
    </Accordion >
  )
}

export default AppAccordion